import React from "react";
import { Modal, Form, Input, Button,  Select} from "antd";
import moment from 'moment'

import useLinkJDStore from "../../store/linkJdModal.store";
import useRDBStore from "../../store/rdb";

import "./linkJDAddModal.scss";

export default function LinkJDModal({jdList,rID,emailID, mobile}) {

    const { islinkJDModelOpen, handleLinkJDModalCancel } = useLinkJDStore();
    const { rdbLinkResumetoJD } = useRDBStore();
    //const jdList = ['JD123','JD23']
    const objectArray = jdList.map((jdid, index) => ({
    label: jdid,
    value: jdid,
    }));    
    const encodeJson = (values) =>{

        let encodedJsonValues ={};

        //now fill the parameters
        encodedJsonValues.jdid=values.jdid;
        encodedJsonValues.resumeid= rID;
        encodedJsonValues.email= emailID;
        encodedJsonValues.mobile= mobile;
        encodedJsonValues.userid=values.clientdescription;
        encodedJsonValues.username=values.clientlocation;
            
        return encodedJsonValues
    }

    const handleFormSubmit = (value) => {
        const jasonValues = encodeJson(value)
        rdbLinkResumetoJD(jasonValues)
        handleLinkJDModalCancel();
    };

    const getTitle = () => {
        return "Select JD to Link --->" + rID
    };

    return (
        <Modal
            title= { getTitle() } 
            visible={islinkJDModelOpen}
            footer={null}
            onCancel={handleLinkJDModalCancel}
            className="subUserAddModel-title"
        >
        <Form
            labelCol={{ flex: "150px" }}
            labelAlign="left"
            labelWrap
            wrapperCol={{ flex: 1 }}
            colon={false}
            onFinish={handleFormSubmit}
        >

            <Form.Item
                rules={[
                        {
                           required: true,
                           message: "Please Select JD",
                        },
                ]}
                label="JD ID"
                name="jdid"
            >
                <Select
                    className="role"                            
                    defaultValue="Select"
                    options={objectArray}
                /> 
            </Form.Item> 

                    <Button htmlType="submit" type="primary">
                        Submit
                    </Button>
        </Form>

        </Modal>
    );
}
